import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { UpgradePopover } from './UpgradePopover';

export const UPGRADE_POPOVER = Symbol('UPGRADE_POPOVER');

export const useUpgradePopover = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(UPGRADE_POPOVER, UpgradePopover);
  });

  return useCallback(
    ({ referenceElement, origin, placement }) => {
      popups.openPopup(UPGRADE_POPOVER, {
        referenceElement,
        origin,
        placement,
        onClose: () => {
          popups.closePopup(UPGRADE_POPOVER);
        },
      });
    },
    [popups]
  );
};
